export interface IIntercomState {}

const initialState: IIntercomState = {}

export function initialIntercomState() {
  return { ...initialState };
}
